export const TRIP_LANGUAGE = "TRIP_LANGUAGE" 